import React from 'react';
import { useSortingModel } from '../../hooks/useSortingModel';
import SortingModelEnhanced from './SortingModelEnhanced';
import { ReactComponent as NewSortModel } from "../../Assets/Icons/NewSortModel.svg";
import styled from 'styled-components';

const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #333333;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #555555;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const SortingModelTrigger = ({ 
  children, 
  buttonText = "Sorting Model",
  showIcon = true,
  className,
  ...buttonProps 
}) => {
  const { isVisible, showSortingModel, hideSortingModel } = useSortingModel();

  const handleClick = () => {
    showSortingModel();
  };

  return (
    <>
      <TriggerButton 
        onClick={handleClick}
        className={className}
        {...buttonProps}
      >
        {showIcon && <NewSortModel />}
        {children || buttonText}
      </TriggerButton>

      <SortingModelEnhanced
        isSelectModelVisible={isVisible}
        setIsSelectModelVisible={hideSortingModel}
      />
    </>
  );
};

export default SortingModelTrigger;
